import React from 'react';

import {
  useWeaveServer,
  WeaveVersion,
} from '../../../ComputeGraphContextProvider';
import {useViewer} from '../../../state/viewer/hooks';
import {queue as queueUrl} from '../../../util/urls';
import {Queue} from '../Queues/queueUtil';
import {Tab} from '../Tab';
import {Tabs} from '../Tabs';
import {WANDB_ENTITY_NAME, WANDB_PUBLIC_QUEUE_NAME} from '../utils';

type QueueDetailTabsProps = {
  entityName: string;
  queue: Queue;
  tab: string;
};

export const QueueDetailTabs = ({
  entityName,
  queue,
  tab,
}: QueueDetailTabsProps) => {
  const weaveVersion = useWeaveServer()[1];
  const viewer = useViewer();
  const onlyShowRuns =
    viewer?.entity !== 'wandb' &&
    entityName === WANDB_ENTITY_NAME &&
    queue.name === WANDB_PUBLIC_QUEUE_NAME;

  // When onlyShowRuns is true, force tab to be "runs"
  // otherwise the tab from the url will be invalid and
  // we'll get a material-ui validation error
  const validTab = onlyShowRuns && tab !== 'runs' ? 'runs' : tab;

  const tabs = [
    <Tab
      key="runs"
      label="Runs"
      value="runs"
      href={queueUrl(entityName, queue.id, 'runs')}
    />,
  ];

  if (!onlyShowRuns) {
    tabs.push(
      <Tab
        key="agents"
        label="Agents"
        value="agents"
        href={queueUrl(entityName, queue.id, 'agents')}
      />,
      <Tab
        key="config"
        label="Config"
        value="config"
        href={queueUrl(entityName, queue.id, 'config')}
      />
    );

    if (weaveVersion === WeaveVersion.V1) {
      tabs.push(
        <Tab
          key="monitor"
          label="Monitor"
          value="monitor"
          href={queueUrl(entityName, queue.id, 'monitor')}
        />
      );
    }
  }

  return <Tabs value={validTab}>{tabs}</Tabs>;
};
